import authService from '@platform/core/src/services/authService';
import config from '@platform/core/src/config';

const API_BASE_URL = config.API_BASE_URL;
const LOOKUPS_API_PREFIX = '/api/v1/lookups';

/**
 * Fetches the application-wide lookup data (units, levels, etc.) from the backend.
 * @returns {Promise<Object>} An object containing arrays of lookup values for different categories.
 * @throws {Error} If fetching fails.
 */
export const getLookups = async () => {
  const url = `${API_BASE_URL}${LOOKUPS_API_PREFIX}`;
  try {
    const response = await authService.authFetch(url);
    if (!response.ok) {
      let errorDetail = `Failed to fetch app lookups: ${response.status}`;
      try {
        const errorData = await response.json();
        errorDetail = errorData.detail || errorDetail;
      } catch (e) {  }
      throw new Error(errorDetail);
    }
    const lookups = await response.json();
    return lookups;
  } catch (error) {
    console.error('[workoutsmart/lookupsApi] Error fetching app lookups:', error);
    authService.trackNetworkError('getLookups', error);
    throw error;
  }
};